// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const DisabledIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M32 5.33a26.68 26.68 0 0 0 0 53.34 26.68 26.68 0 0 0 0-53.34M10.67 32a21.33 21.33 0 0 1 34.4-16.83l-29.9 29.9A21 21 0 0 1 10.67 32M32 53.33c-4.93 0-9.47-1.68-13.07-4.5l29.9-29.9A21.33 21.33 0 0 1 32 53.33"
    />
  </svg>,
  "Disabled",
);
export default DisabledIcon;
